import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconArLabelStyle0 = cosmosIconCss;

const CosmosIconArLabel$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArLabel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '9b1222e6e6d0d462a1f4bd39e6185a5308edb31c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6c84e685aa682850eefcad4659b207d4dd9f660d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e623e8db4594247e367b13af2b2f88da90bc3f71', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.48 13.336H6.972l-.485 1.414H5L7.468 8h1.507l2.458 6.75H9.946l-.466-1.414Zm-2.15-1.093h1.793l-.902-2.829-.892 2.829ZM12.354 8h2.319c.363 0 .689.05.976.15.288.1.534.243.739.427.205.184.362.41.47.677.11.267.164.568.164.902 0 .462-.102.856-.307 1.184a1.916 1.916 0 0 1-.872.742l1.635 2.668h-1.635l-1.438-2.447h-.634v2.447h-1.417V8Zm2.27 3.15c.31 0 .553-.088.728-.261.175-.174.263-.415.263-.723 0-.3-.086-.536-.258-.707-.172-.17-.416-.255-.734-.255h-.862v1.945h.862Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconArLabelStyle0; }
}, [1, "cosmos-icon-ar-label", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-ar-label"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-ar-label":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArLabel$1);
            }
            break;
    } });
}

const CosmosIconArLabel = CosmosIconArLabel$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArLabel, defineCustomElement };
